import { GroupBase, type GroupProps } from "../shared/GroupBase";
import {
  Input,
  InputRightElement,
  type InputProps,
  InputGroup as ChakraInputGroup,
} from "@chakra-ui/react";
import { Icon } from "../icon/Icon";
import { type InputFlair, inputFlairStyle } from "./inputFlair";

interface InputGroupProps extends GroupProps, InputProps {
  layoutProps?: GroupProps;
  flair?: InputFlair;
}

/**
 * Text inputs let users enter short, single-line information in forms. They
 * collect values that users type manually, such as names, identifiers, CIDR
 * blocks, or configuration values. For long-form content use Textarea; for
 * secrets use Password input.
 */
export const InputGroup = ({
  name,
  label,
  error,
  caption,
  autoFocus = true,
  readOnly,
  isDisabled,
  layoutProps,
  inputRightIconName,
  children,
  hideLabel,
  flair,
  ...rest
}: InputGroupProps) => (
  <GroupBase
    name={name}
    label={label}
    error={error}
    caption={caption}
    isDisabled={isDisabled}
    hideLabel={hideLabel}
    fieldId={rest.id}
    {...layoutProps}
  >
    <ChakraInputGroup>
      <Input
        autoFocus={autoFocus}
        name={name}
        isInvalid={Boolean(error)}
        isDisabled={isDisabled}
        borderRadius="lg"
        sx={{
          fontVariantLigatures: "none",
          ...(readOnly && {
            backgroundColor: "bg.default",
          }),
        }}
        readOnly={readOnly}
        data-flair={flair}
        style={{ ...inputFlairStyle(flair), ...rest.style }}
        {...rest}
      />
      {inputRightIconName && (
        <InputRightElement pointerEvents="none">
          <Icon name={inputRightIconName} />
        </InputRightElement>
      )}
    </ChakraInputGroup>

    {children}
  </GroupBase>
);
